import { connect, FormikProps } from 'formik';
import React from 'react';
import { DFValues } from './types';

interface Props {
  formik: FormikProps<DFValues>;
}

const Debug: React.FC<Props> = props => {
  const { isValid, values, errors, touched } = props.formik;
  return (
    <>
      <div style={{ marginTop: 120 }} />
      <h5>Validity</h5>
      <pre>{JSON.stringify(isValid, null, 2)}</pre>
      <h5>Value</h5>
      <pre>{JSON.stringify(values, null, 2)}</pre>
      <h5>Errors</h5>
      <pre>{JSON.stringify(errors, null, 2)}</pre>
      <h5>Touched</h5>
      <pre>{JSON.stringify(touched, null, 2)}</pre>
    </>
  );
};

export default connect<{}>(Debug);
